import styled from "styled-components";

export const Background = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    background-image: url("/images/vmsphotos/bgblur.png");
    background-repeat: no-repeat;
    background-size: cover;
    height: 595px;
  }
  @media (max-width: 360px) {
    background-image: url("/images/vmsphotos/bgblur.png");
    background-repeat: no-repeat;
    background-size: cover;
    height: 595px;
  }
`;

export const Container = styled.div`
  display: flex;
  margin: 0 84px 0 122px;
  height: 64px;
  padding: 18px 0;
  justify-content: space-between;
  aliten-items: center;

  a {
    display: flex;
  }
  @media (max-width: 1024px) {
    margin: 0 30px;
  }

  @media (max-width: 600px) {
    margin-bottom: 90px;
  }
`;

export const Logo = styled.div`
  width:  432px;
  height: 70px;
  background-size: cover;
  background-image: url("/images/icons/Logo (2).png");
  @media (max-width: 600px) {
    width: 200px;
    height: 70px;
    background-size: cover;
    background-image: url("/images/vmsphotos/logo2.png");
  }
`;


export const ReactRouteLink = styled.a``;

export const ButtonLink = styled.a`
  z-index: 400;
  display: block;
  width: 146px;
  height: 48px;
  padding: 9px 48px;
  border-radius: 8px;
  background-color: #d67723;
  color: white;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;
  font-family: NunitoSans-SemiBold;
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0.5px;
  &:hover {
    background-color: #d67723;
  }
  @media (max-width: 600px) {
    margin-top: 10px;
    height: 47px;
    width: 140px;
    font-size: 14px;
    line-height: 20px;
    padding: 15px 47px;
    text-align: center;
  }
  @media (max-width: 768px) {
    margin-top: 10px;
    height: 47px;
    width: 140px;
    font-size: 14px;
    line-height: 20px;
    padding: 15px 47px;
    text-align: center;
  }
  @media (max-width: 360px) {
    margin-top: 10px;
    height: 47px;
    width: 140px;
    font-size: 14px;
    line-height: 20px;
    padding: 15px 47px;
    text-align: center;
  }
  @media (max-width: 320px) {
    margin-top: 10px;
    height: 38px;
    width: 74px;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 15px;
    text-align: center;
  }
`;
